import React from "react";
import { RCCBadge, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import formatNumber from "src/utils/formatNumber";
import { ActionSituation } from "../../interface";

interface IBadgeHistory{
    situation: string;
    value: number;
}

const BadgeHistory: React.FC<IBadgeHistory> = ({
	situation,
	value
}) => {
	const { translate, currentLanguage } = useTranslation();
	return <RCCTooltip
		text={ActionSituation.FINISHED === situation ? translate("Concluída") : translate("Em andamento")}
		color={ActionSituation.FINISHED === situation ? "green" : "blue"}
		position="leftEnd"
	>
		<RCCBadge color={ActionSituation.FINISHED === situation ? "green" : "blue"} styleInline="padding: 2px 8px; font-size: 0.78rem;">
			{formatNumber(value, currentLanguage)}%
		</RCCBadge>
	</RCCTooltip>;
};

export default BadgeHistory;
